'use strict';

Odigeo.defineWidget('gdpr_newsletter', Odigeo.Widget.extend({
    viewClass: require('./view'),

    setNewsletterEmail(email) {
        this.view.setNewsletterEmail(email);
    },

    setUnsubscribeFromUrl(url) {
        this.view.setUnsubscribeFromUrl(url);
    },

    setSubscriptionUser(isSubscription) {
        this.view.setSubscriptionUser(isSubscription);
    },

    setNewsletterCampaign(campaign) {
        this.view.setNewsletterCampaign(campaign);
    },

    suscribeToNewsletter() {
        this.view.suscribeToNewsletter();
    },

    unsubscribeToNewsletter() {
        this.view.unsubscribeToNewsletter();
    },

    onClickNewsletterSubscription(showModal) {
        this.view.onClickNewsletterSubscription(showModal);
    },

    onClickNewsletterUnsubscription(showModal) {
        this.view.onClickNewsletterUnsubscription(showModal);
    },
}));
